import { IconContent } from '@icons';

export const lastPage: IconContent = {
    sm: '<path d="M9.15 8 5 12.15l.7.7L10.57 8 5.71 3.15l-.71.7L9.15 8Z"/><path d="M11.28 13V3h-1v10h1Z"/>',
};
